// extracted by mini-css-extract-plugin
export default {"column__container":"styles_column__container__OFnyd","column__text":"styles_column__text__Df7hy"};